module.exports = __webpack_public_path__ + "static/413-85d8f4687d58b9e4c039e5ec56ea4db4.png";